import React from "react";
import * as jotoTypes from "../../api/joto-types";
import * as joto from "../../api/joto";
import * as jotoui from "../../joto-ui-api";
import {ILikeThis} from "../ILikeThis";
import {PositionProperty} from "csstype";
import * as jotouiutils from "../JotoUIUtils";
import {generateDummyPicture} from "../JotoUIUtils";
import {profitOptions, projectStateOptions} from '../JotoUIUtils';

import * as env from "../../env";

import * as log from 'loglevel';
import Disqus from "disqus-react";



// log.setDefaultLevel(log.levels.DEBUG);
const logger = log.getLogger('ProjectDetail.tsx');
logger.setLevel(env.logLevel);

interface ProjectDetailBasicProps {
    joto: joto.Joto,
    jotoui: jotoui.JotoUIApi,
    likeElement: boolean,
    closeElement: boolean,
    userNickName: string | null,
    permLinkPage: boolean | undefined,
    propertySelectedProject: jotoTypes.Project
}

/*
 * How To Use Async Await in React (componentDidMount Async)
 * https://www.valentinog.com/blog/await-react/
 * https://www.valentinog.com/blog/hooks/
 */

export class ProjectDetailBasic  extends React.Component<ProjectDetailBasicProps, {}> {
    constructor(props: ProjectDetailBasicProps){
        super(props);

        this.getProject = this.getProject.bind(this);
        this.closeDivProjectDetailPage = this.closeDivProjectDetailPage.bind(this);
        this.fnlike = this.fnlike.bind(this);
        this.contactProjectOwner = this.contactProjectOwner.bind(this);
    }

    getProject() : jotoTypes.Project | null {
        return this.props.propertySelectedProject;
    }

    closeDivProjectDetailPage() {
        this.props.jotoui.showProjectDetailPage(null);
    }

    fnlike() {
        if(!this.props.joto.userData) {
            this.props.jotoui.failedMessage.apply(this.props.jotoui, jotoui.likeNotLoggedInMessage);
            return;
        }

        const project = this.getProject();
        if(project != null)
            this.props.jotoui.likeToggle(project);
    }

    contactProjectOwner() {
        if(!this.props.joto.userData) {
            this.props.jotoui.failedMessage('Kontakt', 'Du bist nicht eingelogged. Deshalb kannst Du das Kontaktformular nicht aufrufen. Log Dich ein um Kontakt zum Projektersteller aufzunehmen.');
            return;
        }

        if((window as any).$) {
            (window as any).$('#project-detail-modal-contact-form').modal('show');
            (window as any).$('#main-selected-project-modal-view').modal('hide');
        }
    }

    render() {
        const project = this.getProject();
        if (project == null){
            return null
        }
        let permlink_close = null;
        let like_element = null;
        const pp : PositionProperty = "absolute";

        const close_icon_style = { // : SVGProps<SVGSVGElement>
            position: pp,
            top: '0px',
            right: '0px',
        };
        if (this.props.closeElement){
            permlink_close = (
            <div key={`permlink_close_${project.uid}_${project.uid}_pid`}>
                <svg xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    className={'feather'}
                    style={close_icon_style}
                    onClick={(e) => {e.preventDefault(); e.stopPropagation(); this.closeDivProjectDetailPage();}}>
                    <use xlinkHref="/svg/joto.svg#x-circle"/>
                </svg>
            </div>
            );
        }
        if (this.props.likeElement){
            like_element = <ILikeThis key={`ilike_${project.uid}_${project.uid}_pid`} path={project} fnlike={this.fnlike} projectDetailPage={true}/>
        }else {
            like_element = <div></div> //<div><ILikeThis key={`ilike_${project.uid}_${project.uid}_pid`} path={project}/></div>
        }


        const url_ = jotouiutils.createPermLinkUrl(project);
        const url = encodeURIComponent(url_);
        const subject = encodeURI(project.name);
        logger.debug(`ProjectDetailBasic.tsx: url: ${url}`);

        // https://github.com/disqus/disqus-react
        // disqusProps.config.url must match Website URL
        // https://https-joto-prekt-dev-eu.disqus.com/admin/settings/general/
        const id = `/${project.uid}/${project.pid}`;
        const disqusShortname = env.disqusShortname; // 'https-joto-prekt-dev-eu';
        const disqusConfig = {
            url: env.project_base_url + '/projects' + id,
            identifier: encodeURIComponent(id),
            title: project.name,
        };
        logger.debug('disqusShortname: ' + disqusShortname);
        logger.debug(JSON.stringify(disqusConfig, null, 2));
        // <Disqus.DiscussionEmbed shortname={disqusShortname} config={disqusConfig} />
        let permLinkElement;
        if(this.props.permLinkPage) {
            permLinkElement = (
                <>
                    <br/>
                    <button type="button" className="btn btn-dark">
                        <a  href={jotouiutils.createProjectMainPageLinkUrl(project)} target='_blank' rel="noopener noreferrer">Zur Hauptprojektseite und zum Login</a>
                    </button>

                </>);
        } else {
            permLinkElement = (
                <a href={jotouiutils.createProjectLinkUrl(project)} target='_blank' rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlnsXlink="http://www.w3.org/1999/xlink"
                         className={'feather'}>
                        <use xlinkHref="/svg/joto.svg#link"/>
                    </svg>
                </a>);
        }
        let pictureURL = '' + project.pictureURL;
        if(pictureURL.trim().length === 0)
            pictureURL = generateDummyPicture(project.name);
        
        const forProfitLabel= profitOptions.reduce(function(filtered: string[], object){
                if(object.value === project.forProfit){
                    filtered.push(object.label)
                }
                return filtered;
            }, [])[0]
        const projectStateLabel = projectStateOptions.reduce(function(filtered: string[], object){
            if (object.value === project.state){
                filtered.push(object.label)
            }
            return filtered; 
        }, [])[0]

        return ( 
            <div>
                <div className="project-detail-header">
                    <div className="row">
                        <div className="col-10">
                            <h1 className="project-name" >{project.name}</h1>
                            <p >{project.abstract}</p>
                        </div>
                        <div className="col-2">
                            {like_element}
                            {permlink_close}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <a className="resp-sharing-button__link" href={`https://facebook.com/sharer/sharer.php?u=${url}`} target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook">
                                <div className="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"><div aria-hidden="true" className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/></svg>
                                </div></div>
                            </a>

                            <a className="resp-sharing-button__link" href={`https://twitter.com/intent/tweet/?text=${subject}&url=${url}`} target="_blank" rel="noopener noreferrer" aria-label="Share on Twitter">
                                <div className="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"><div aria-hidden="true" className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"/></svg>
                                </div></div>
                            </a>

                            <a className="resp-sharing-button__link" href={`mailto:?subject=${subject}&body=${url}`} target="_self" rel="noopener" aria-label="Share by E-Mail">
                                <div className="resp-sharing-button resp-sharing-button--email resp-sharing-button--small"><div aria-hidden="true" className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z"/></svg>
                                </div></div>
                            </a>

                            {permLinkElement}

                        </div>
                    </div>
                </div>
                <div className="row" style={{marginBottom: "5rem"}}>
                    <div className="col-lg-8 order-2 order-lg-1">
                        {/* Article */}
                        <img className="img-fluid mx-auto article-img project-detail-img" src={pictureURL} alt="vortraege-bei-partnern-organisieren"/>
                        <div className="project-detail-description">
                            <h2 id="project-detail-description-header">Projektbeschreibung</h2>
                            <p className="">{project.description}<br/><br/></p>
                            <div className="row">
                                <div className="col-lg-3">Kontakt: </div>
                                <div className="col-lg-9">
                                <span>{this.props.userNickName}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         xmlnsXlink="http://www.w3.org/1999/xlink"
                                         style = {{
                                             marginLeft: 10
                                         }}
                                         className={'feather'}
                                         onClick={(e) => {e.preventDefault(); e.stopPropagation(); this.contactProjectOwner()}}>
                                        <use xlinkHref="/svg/joto.svg#mail"/>
                                    </svg>

                                </div>
                            </div>
                        </div>
                    </div>
                
                <div className="col-lg-4 order-lg-2 order-1">
                    {/*Properties*/}
                    <div className="card my-4" id="property-card">
                        <h3 className="card-header" id="property-header">Eigenschaften</h3>
                        <div className="card-body">
                            <div className="row project-property">
                                <div className="col-md-12 property">Ort</div>
                                <div className="col-md-12">{project.city ? project.city: 'Ortsunabhängig'}</div>
                            </div>      
                            <div className="row project-property">
                                <div className=" col-md-12 property">Projektstatus</div>
                                <div className=" col-md-12">{projectStateLabel}</div>
                            </div>         
                            <div className="row project-property">
                                <div className=" col-md-12 property">Profitorientiert</div>
                                <div className=" col-md-12">{forProfitLabel}</div>
                            </div>
       
                        </div>
                    </div>
                </div>
                </div>
                <Disqus.DiscussionEmbed shortname={disqusShortname} config={disqusConfig} />
            </div>
        ); // https://github.com/disqus/disqus-react/issues/42 Deprecation warning in disqus/disqus-react
    }
}
